export default __webpack_public_path__ + "static/media/background_information.0fef520b.svg";